/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
document.addEventListener('DOMContentLoaded', () => {
  const isKeepEager = (img) => {
    // keep the logo + the very first hero image eager
    const logo = document.querySelector('.site-header img, header .site-logo img');
    const hero = document.querySelector('.js-section__home-slider img'); // first img inside slideshow
    return img === logo || img === hero;
  };

  const patch = (img) => {
    if (!img || img.dataset.aiLazyPatched) return;
    if (isKeepEager(img)) { img.dataset.aiLazyPatched = '1'; return; }
    img.setAttribute('loading', 'lazy');
    img.setAttribute('decoding', 'async');
    if (img.getAttribute('fetchpriority') !== 'low') img.setAttribute('fetchpriority', 'auto');
    img.dataset.aiLazyPatched = '1';
  };

  // patch existing
  [...document.images].forEach(patch);

  // patch anything added later
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === 'childList') {
        m.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'IMG') patch(n);
          n.querySelectorAll && n.querySelectorAll('img').forEach(patch);
        });
      } else if (m.type === 'attributes' && m.target.tagName === 'IMG' && m.attributeName === 'loading') {
        patch(m.target);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['loading'] });
});

